import { Popover } from '@bambi/component-library/src/components/Popover/Popover';

import {
  DispatchTripRead,
  RunBambiRunReassignedTripRead,
  RunBambiRunTripRead,
  TripRead,
} from 'src/common/external/bambi-api/bambiApi';

import { RunBambiRunCalendarEventType } from '../../common/RUN_BAMBI_RUN_ASSIGNMENT_CATEGORIES';
import { TripDetails } from './TripDetails';

export type TripDetailsPopoverProps = {
  trip:
    | DispatchTripRead
    | RunBambiRunTripRead
    | RunBambiRunReassignedTripRead
    | TripRead;
  type?: RunBambiRunCalendarEventType;
  children: React.ReactNode;
};

export const TripDetailsPopover = ({
  trip,
  type,
  children,
}: TripDetailsPopoverProps) => (
  <Popover
    trigger={
      // This could go in the Popover component itself but want to keep fix small
      // Without the div, the popover will sometimes not open
      // h-full makes sure bottom border shows by constraining this to height of container
      // Especially important for assigned calendar event components which have bottom borders
      <div className="h-full" data-testid="trip-details-popover">
        {children}
      </div>
    }
    content={<TripDetails trip={trip} type={type} />}
  />
);
